export default __webpack_public_path__ + "static/media/linkedin.2b251ce5.svg";